import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        },
    ],
})
export class CheckboxComponent implements ControlValueAccessor {
    public checked: boolean = false;

    public disabled = false;

    @Output() public readonly enable = new EventEmitter<boolean>();

    private onChange: ((val: boolean) => void) | undefined;

    private onTouched: (() => void) | undefined;

    public onCheckboxClick(): void {
        if (this.onChange) {
            this.onChange(this.checked);
        }

        if (this.onTouched) {
            this.onTouched();
        }
    }

    public registerOnChange(fn: () => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public writeValue(obj: boolean): void {
        this.checked = obj;
    }
}
